import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api-service';
import { API } from '../../API';

export interface Demande {
  demande_id: number;
  entity_type: string;
  demande_type: string;
  demande_status: string;
  data_first_name?: string;
  data_last_name?: string;
  data_identity_number?: string;
  submitted_by_name?: string;
  club_name?: string;
  licenceperiod_name?: string;
  created_at: string;
  updated_at?: string;
  motif?: string;
}

export interface DemandeDetail extends Demande {
  [key: string]: any;
}

export interface DemandesResponse {
  success: boolean;
  data: Demande[];
  total: number;
  pagination?: { page: number; limit: number; total: number; totalPages: number };
}

export interface DemandeStats {
  total_pending: number;
  total_validated: number;
  total_rejected: number;
  total_cancelled: number;
  total: number;
}

@Injectable({ providedIn: 'root' })
export class DemandesService {
  constructor(private api: ApiService) {}

  list(entityType: string, body: any): Observable<DemandesResponse> {
    return this.api.post(API.DEMANDES.LIST.replace(':entity_type', entityType), body);
  }

  getDetail(entityType: string, id: number): Observable<any> {
    return this.api.post(API.DEMANDES.DETAIL.replace(':entity_type', entityType).replace(':id', String(id)), {});
  }

  submit(entityType: string, body: any): Observable<any> {
    return this.api.post(API.DEMANDES.SUBMIT.replace(':entity_type', entityType), body);
  }

  validate(entityType: string, body: any): Observable<any> {
    return this.api.post(API.DEMANDES.VALIDATE.replace(':entity_type', entityType), body);
  }

  reject(entityType: string, body: any): Observable<any> {
    return this.api.post(API.DEMANDES.REJECT.replace(':entity_type', entityType), body);
  }

  cancel(entityType: string, body: any): Observable<any> {
    return this.api.post(API.DEMANDES.CANCEL.replace(':entity_type', entityType), body);
  }

  getStats(): Observable<any> {
    return this.api.get(API.DEMANDES.STATS);
  }

  transferClubAccept(body: any): Observable<any> {
    return this.api.post(API.DEMANDES.TRANSFER_CLUB_ACCEPT, body);
  }

  transferClubReject(body: any): Observable<any> {
    return this.api.post(API.DEMANDES.TRANSFER_CLUB_REJECT, body);
  }
}
